let pending = "";
const listeners = new Set();

export const setBookingDoctor = (name) => {
  pending = name;
  listeners.forEach((fn) => fn(name));
};

export const subscribeBookingDoctor = (fn) => {
  listeners.add(fn);
  if (pending) fn(pending);
  return () => listeners.delete(fn);
};
